/**
 * IMUCET Coaching page scripts
 *
 * Handles table-of-contents toggle on small screens and in-page smooth scroll.
 */
(function () {
    'use strict';

    const toc = document.querySelector('.imucet-coaching-toc');
    const toggle = document.getElementById('imucet-coaching-toc-toggle');
    const list = document.getElementById('imucet-coaching-toc-list');

    if (!toc || !toggle || !list) {
        return;
    }

    const handleToggle = () => {
        const isOpen = toc.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    };

    toggle.addEventListener('click', handleToggle);

    list.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLAnchorElement)) {
            return;
        }

        if (window.matchMedia('(max-width: 767px)').matches && toc.classList.contains('is-open')) {
            toc.classList.remove('is-open');
            toggle.setAttribute('aria-expanded', 'false');
        }
    });
})();
